(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateCounter(element) {
    if (element.dataset.mcCountDone === 'true') return;

    const target = Number(String(element.dataset.count || '').replace(/,/g, ''));
    if (!Number.isFinite(target)) return;

    const prefix = element.dataset.prefix || '';
    const suffix = element.dataset.suffix || '';
    const duration = Number(element.dataset.duration || 1400);

    element.dataset.mcCountDone = 'true';

    if (reducedMotion) {
      element.textContent = `${prefix}${target.toLocaleString()}${suffix}`;
      return;
    }

    let startTime = null;
    const step = (time) => {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.floor(target * eased);
      element.textContent = `${prefix}${value.toLocaleString()}${suffix}`;
      if (progress < 1) window.requestAnimationFrame(step);
    };

    window.requestAnimationFrame(step);
  }

  function initReveal(root = document) {
    const revealItems = root.querySelectorAll('[data-mc-k-reveal]:not([data-mc-reveal-ready])');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((element) => {
        element.dataset.mcRevealReady = 'true';
        element.classList.add('mc-k-in-view');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mc-k-in-view');
          if (entry.target.classList.contains('mc-k-expertise')) {
            entry.target.classList.add('is-in-view');
          }
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.13, rootMargin: '0px 0px -40px' }
    );

    revealItems.forEach((element) => {
      element.dataset.mcRevealReady = 'true';
      observer.observe(element);
    });
  }

  function initCounters(root = document) {
    const counters = root.querySelectorAll('[data-count]:not([data-mc-count-ready])');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      counters.forEach((counter) => {
        counter.dataset.mcCountReady = 'true';
        animateCounter(counter);
      });
      return;
    }

    const counterObserver = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.45 }
    );

    counters.forEach((counter) => {
      counter.dataset.mcCountReady = 'true';
      counterObserver.observe(counter);
    });
  }

  function initHeader() {
    const header = document.querySelector('.template-index header.theme-header');
    if (!header || header.dataset.mcHeaderReady === 'true') return;

    header.dataset.mcHeaderReady = 'true';
    const updateHeader = () => header.classList.toggle('mc-k-scrolled', window.scrollY > 24);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  function initHeroParallax(root = document) {
    if (reducedMotion) return;

    const heroes = root.querySelectorAll('.mc-k-hero:not([data-mc-parallax-ready])');
    heroes.forEach((hero) => {
      hero.dataset.mcParallaxReady = 'true';
      const image = hero.querySelector('.mc-k-hero__media img');
      if (!image) return;

      const update = () => {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const amount = Math.max(0, Math.min(window.scrollY * 0.055, 48));
        image.style.transform = `scale(1.05) translateY(${amount}px)`;
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
    });
  }

  function init(root = document) {
    initReveal(root);
    initCounters(root);
    initHeroParallax(root);
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
